import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { split } from "apollo-link";
import { HttpLink } from "apollo-link-http";
import { WebSocketLink } from "apollo-link-ws";
import { getMainDefinition } from "apollo-utilities";
import gql from "graphql-tag";

export const createApolloClient = () => {
  const httpLink = new HttpLink({
    uri: "https://cute-ape-95.hasura.app/v1/graphql",
  });
  const wsLink = new WebSocketLink({
    uri: `wss://cute-ape-95.hasura.app/v1/graphql`,
    options: {
      reconnect: true,
    },
  });

  const link = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === "OperationDefinition" &&
        definition.operation === "subscription"
      );
    },
    wsLink,
    httpLink
  );

  return new ApolloClient({ link, cache: new InMemoryCache() });
};

export const ADD_QUESTION = gql`
  mutation askquestion(
    $fingerprint: String = ""
    $question: String = ""
    $askedTime: date = ""
  ) {
    insert_questions_one(
      object: {
        fingerprint: $fingerprint
        askedTime: $askedTime
        question: $question
      }
    ) {
      askedTime
    }
  }
`;

export const QUESTIONS = gql`
    subscription questions {
    questions(order_by: { id: desc }) {
      answer
      answeredAt
      askedTime
      fingerprint
      question
      id
    }
  }
`;
